import Dashboard from "./Dashboard";
import MainAccount from "./MainAccount";
import ManageMainAccount from "./ManageMainAccount";
import IncomingTransaction from "./IncomingTransaction";
import OutgoingTransaction from "./OutgoingTransaction";
import ViewTransaction from "./ViewTransaction";
import ViewUserTransaction from "./ViewUserTransaction";
import withType from "./ViewUserTransaction/withType";
import History from "./History";
import { Login, Page404, Page500 } from "./Pages";
import { RegistrationStep, ReInstall } from "./KeyHolderRegistration";
import { Profile, ChangePassword } from "./Settings";
import { TotalAccount, AccountDetail } from "./TotalAccount";
import MobileUser from "./MobileUserActivation";
import MobileUserSearch from "./MobileUserSearch";
import DesktopUser from "./DesktopUserActivation";
import WebUser from "./WebUser";
import KeyRecoveryRequests from "./KeyRecoveryRequests";
import RecoveryDetail from "./RecoveryRequests/detail";
import Download from "./Download";
import AuditLogs from "./AuditLogs";
import {
  WaitingForApproveMobile,
  WaitingForApproveDesktop,
  WaitingForApproveWeb,
} from "./WaitingForApprove";
import { CustomerInfo, MobileCustomerInfo } from "./NewCustomerKYC";
import {
  DesktopLimit,
  MobileLimit,
  WebLimit,
  EditLimit,
  AddLimit,
} from "./KYCLimits";
import {
  TermsAndConditionsMobile,
  TermsAndConditionsDesktop,
} from "./TermsAndConditions";
import ManageAuthorizers from "./ManageAuthorizers";
import BankInfo from "./BankInfo";
import ChangePhoneRequests from "./ChangePhoneRequests";
import RecoveryRequests from "./RecoveryRequests";

import Roles from "./Roles";
import Permissions from "./Permissions";
import Endpoints from "./Endpoints";
import Users from "./Users";

import BlankPage from "./BlankPage";

let Notifications;

if (process.env.NOTIFICATIONS === "true") {
  Notifications = require("./Notifications").Notifications;
}

export {
  BlankPage,
  Dashboard,
  MainAccount,
  ManageMainAccount,
  IncomingTransaction,
  OutgoingTransaction,
  ViewTransaction,
  ViewUserTransaction,
  withType,
  Page404,
  Page500,
  Login,
  History,
  Profile,
  ChangePassword,
  RegistrationStep,
  ReInstall,
  TotalAccount,
  AccountDetail,
  MobileUser,
  MobileUserSearch,
  DesktopUser,
  WebUser,
  KeyRecoveryRequests,
  CustomerInfo,
  MobileCustomerInfo,
  WaitingForApproveMobile,
  WaitingForApproveDesktop,
  WaitingForApproveWeb,
  DesktopLimit,
  MobileLimit,
  WebLimit,
  AddLimit,
  EditLimit,
  TermsAndConditionsMobile,
  TermsAndConditionsDesktop,
  ManageAuthorizers,
  BankInfo,
  ChangePhoneRequests,
  RecoveryRequests,
  RecoveryDetail,
  Roles,
  Permissions,
  Endpoints,
  Users,
  Notifications,
  Download,
  AuditLogs,
};
